import { render, staticRenderFns } from "./IconGiftOutline.vue?vue&type=template&id=52a16651"
import script from "./IconGiftOutline.vue?vue&type=script&lang=js"
export * from "./IconGiftOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports